import { template as template_939f6a7cbc7b476fb491cb982cb7bbfc } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './insurance-section.module.scss';
import t from 'ember-intl/helpers/t';
export default class SiteDocumentsContactInfoChannelCoverageBanner extends Component {
    get remainingSessionsCount() {
        return this.args.channelClientInfo?.remainingSessionsCount;
    }
    get channelName() {
        return this.args.channelClientInfo?.globalMonarchChannel?.displayName;
    }
    static{
        template_939f6a7cbc7b476fb491cb982cb7bbfc(`
    <div class={{styles.component}}>
      <div class="channel-covered">
        <div class="text">
          {{t
            "site.documents.contactInfo.insuranceSection.channelCoverage"
            count=this.remainingSessionsCount
            channelName=this.channelName
          }}
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
